export class MtProgramUserListApiModel {
  public ProgramRoleId: string;
  public FirstName: string;
  public LastName: string;
  public ShiftName: string;
  public LocationName: string;
  public AvatarSrc: string;
  public MentorProgramRoleId: string;
  public MentorFullName: string;
  public MentorAvatarSrc: string;
  public LastVisit: Date;
  public IsRemovable: boolean;
  public ReversedName: string;
  public Name: string;

  public deserialize(data: Object): this {
    Object.assign(this, data);

    this.ReversedName = `${this.LastName}, ${this.FirstName}`;
    this.Name = `${this.FirstName} ${this.LastName}`;
    return this;
  }
}
